import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .get(`/articles/${slug}`)
      .then((r) => setArticle(r.data))
      .catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-32 text-center" data-testid="article-not-found">
        <h1 className="font-serif text-3xl text-[#0F172A]">Article introuvable</h1>
        <Link to="/actualites" className="gpi-btn-outline mt-8">
          Retour aux actualités
        </Link>
      </div>
    );
  }

  if (!article) return <div className="py-32 text-center text-[#64748B]">Chargement...</div>;

  return (
    <div data-testid="page-article-detail">
      {article.cover_image && (
        <div className="-mt-[96px] lg:-mt-[144px] h-[60vh] min-h-[400px] relative">
          <img src={article.cover_image} alt={article.title} className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 gpi-hero-overlay" />
        </div>
      )}
      <article className="max-w-3xl mx-auto px-4 py-20">
        <Link
          to="/actualites"
          className="inline-flex items-center gap-2 text-sm text-[#64748B] hover:text-[#0F172A] transition-colors"
          data-testid="article-back-link"
        >
          <ArrowLeft size={14} />
          Retour aux actualités
        </Link>
        <div className="mt-8">
          <span className="font-overline-lg text-[#B8935A]">{article.category}</span>
          <h1 className="font-serif text-4xl lg:text-5xl text-[#0F172A] mt-4 leading-tight">
            {article.title}
          </h1>
          <p className="text-[#64748B] mt-6 text-lg leading-relaxed">{article.excerpt}</p>
        </div>
        <hr className="my-12 border-[#E2E8F0]" />
        <div
          className="gpi-prose"
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
      </article>
    </div>
  );
}
